/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import ArtistService from '../../services/artistService';

const Welcome = (props) => { 
    const activeProfile = props.activeProfile;
    const newUser = props.newUser;
    return (        
        <div className="main">
            <MetaTags>       
                <title>LoudUp - Welcome!</title>      
            </MetaTags>
            <div className="container">
                <div className="block-inner">            
                    <div className="row">
                        <div className="col-sm-12">
                            <article className="body-copy">
                                <header>
                                    <h2 className="section-alt">{newUser ? "You're in!" : "Welcome Back!"}</h2>
                                </header>
                                <div className="body-narrow">
                                    <div className="text-center">
                                        <p>Check out your {ArtistService.getRoleTypeFriendlyName(activeProfile.RoleType).toLowerCase()} profile at:</p>
                                        <Link to={`/${activeProfile.Username}`} className="btn-yourprofile">www.loudup.com/{activeProfile.Username}</Link>

                                        <p>{newUser ? "Let's help you get started..." : "Here are a few shortcuts..."}</p>
                                    </div>
                                    <ul className="list-unstyled list-tilesections">
                                        <li>
                                            <Link to="/">
                                                <img src={require('../../Images/picto-sect-home.png')} alt="Home" />
                                                <p>Go to the <br />homepage</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/HowItWorks">
                                                <img src={require('../../Images/picto-sect-how-it-works.png')} alt="How LoudUp Works" />
                                                <p>Find out how <br />LoudUp works</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Artists">
                                                <img src={require('../../Images/picto-sect-artists.png')} alt="Artists" />
                                                <p>Browse <br />artists</p>
                                            </Link>
                                        </li>
                                        { 
                                            activeProfile.RoleType === 'Artist' ?
                                                <li>
                                                    <Link to="/Producers">
                                                        <img src={require('../../Images/picto-sect-producers.png')} alt="Producers" />
                                                        <p>Browse <br />producers</p>
                                                    </Link>
                                                </li>
                                            : null
                                        }
                                        {
                                            activeProfile.RoleType === 'Artist' || activeProfile.RoleType === 'RecordLabel' ? 
                                                <React.Fragment>
                                                    <li>
                                                        <Link to="/PromoteYourMusic">
                                                            <img src={require('../../Images/picto-sect-music-promo.png')} alt="Music Promotion Guide" />
                                                            <p>Check out the <br />Music Promotion Guide</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Unsigned">
                                                            <img src={require('../../Images/picto-sect-blog.png')} alt="Unsigned Guide" />
                                                            <p>Check out the guide <br />for unsigned artists</p>
                                                        </Link>
                                                    </li>
                                                </React.Fragment>
                                            : null
                                        }
                                        <li>
                                            <Link to="/Discover">
                                                <img src={require('../../Images/picto-sect-reviews.png')} alt="Reviews" />
                                                <p>Check out <br />track reviews</p>
                                            </Link>
                                        </li>
                                        { 
                                            activeProfile.RoleType !== 'Artist' && activeProfile.RoleType !== 'RecordLabel' ?
                                                <li>
                                                    <Link to="/Blog">
                                                        <img src={require('../../Images/picto-sect-blog.png')} alt="Blog" />
                                                        <p>Check out <br />the blog</p>
                                                    </Link>
                                                </li>
                                            : null
                                        }
                                        <li>
                                            <Link to="/Discussions">
                                                <img src={require('../../Images/picto-sect-discussion.png')} alt="Discussion" />
                                                <p>Check out<br />the discussions</p>
                                            </Link>
                                        </li>
                                        { 
                                            activeProfile.RoleType === 'Fan' ?
                                                <li>
                                                    <Link to="/Fans">
                                                        <img src={require('../../Images/picto-sect-fans.png')} alt="Fans" />
                                                        <p>Browse <br />fans</p>
                                                    </Link>
                                                </li>
                                            : null
                                        }
                                        { 
                                            activeProfile.RoleType === 'Artist' ?
                                                <li>
                                                    <Link to="/Musicians">
                                                        <img src={require('../../Images/picto-sect-musicians.png')} alt="Musicians" />
                                                        <p>Browse <br />musicians</p>
                                                    </Link>
                                                </li>
                                            : null
                                        }
                                        <li>
                                            <Link to="/Gigs">
                                                <img src={require('../../Images/picto-sect-gigs.png')} alt="Upcoming Gigs" />
                                                <p>Check out the <br />upcoming gigs</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/Charts">
                                                <img src={require('../../Images/picto-sect-charts.png')} alt="Trending Charts" />
                                                <p>Check out the charts<br />to see what's trending</p>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Welcome.propTypes = {
    activeProfile: PropTypes.object,
    newUser: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return { 
        newUser: state.account.newSignup,
        activeProfile: state.account.user.activeProfile 
    };
}

export default connect(mapStateToProps)(Welcome);